import React from "react";
import { BoxSection } from "../../../../../../components";
import { Col, Row } from "antd";
import BoxSectionItem from "../../../../../../components/box-section/box-section-item";

export const ECViDetail = () => {
  return (
    <>
      <BoxSection title="Thông tin đơn xác nhận">
        <Row gutter={[32, 0]}>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem
              textLeft="Họ và tên người yêu cầu"
              textRight="Tên account"
            />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Chức danh" textRight="Tên chức danh" />
          </Col>
        </Row>
      </BoxSection>
      <BoxSection title="Thông tin chi tiết">
        <Row gutter={[32, 0]}>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Họ và tên" textRight="Tên" />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Số CMND/CCCD" textRight="0123456789" />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Chức danh" textRight="Tên chức danh" />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Ngày vào nghành" textRight="1/1/2020" />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem textLeft="Chi nhánh" textRight="Tên chi nhánh" />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem
              ellipsis
              textLeft="Ngày giấy chứng nhận hết hạn"
              textRight="12/7/2023"
            />
          </Col>
          <Col span={12} xs={24} md={12}>
            <BoxSectionItem
              ellipsis
              textLeft="Giấy chứng nhận này cấp cho Ông/bà"
              textRight="Tên ông/bà"
            />
          </Col>
        </Row>
      </BoxSection>
    </>
  );
};
